var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThumb = function SvgThumb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20424",
    "data-name": "Group 20424",
    width: 49.554,
    height: 44.555,
    viewBox: "0 0 49.554 44.555",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20423",
    "data-name": "Group 20423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Zoom_In",
    "data-name": "Zoom In"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20422",
    "data-name": "Group 20422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20421",
    "data-name": "Group 20421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20420",
    "data-name": "Group 20420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20419",
    "data-name": "Group 20419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20418",
    "data-name": "Group 20418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20417",
    "data-name": "Group 20417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20416",
    "data-name": "Group 20416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20415",
    "data-name": "Group 20415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Play_-_Orange",
    "data-name": "Play - Orange"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow_Right_-_Orange",
    "data-name": "Arrow Right - Orange"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20414",
    "data-name": "Group 20414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11255",
    "data-name": "Path 11255",
    d: "M49.635,27.426a6.286,6.286,0,0,1-.3.944c-.278.556-.61,1.086-.9,1.636a.712.712,0,0,0-.109.505,5.068,5.068,0,0,1-.814,5.106.552.552,0,0,0-.114.616A4.962,4.962,0,0,1,46.751,41a1.213,1.213,0,0,0-.233,1.1,5.414,5.414,0,0,1-1.241,5.248A4.527,4.527,0,0,1,42.8,48.69a14.12,14.12,0,0,1-2.546.278H21.388a5.71,5.71,0,0,1-3.182-1.056,1.176,1.176,0,0,0-.943-.242,7.033,7.033,0,0,1-.074.924,2,2,0,0,1-1.822,1.813,3.873,3.873,0,0,1-.432,0H2.383a2.1,2.1,0,0,1-1.6-.552,2.178,2.178,0,0,1-.7-1.565q0-9.99,0-19.976a2.275,2.275,0,0,1,.634-1.727,2.193,2.193,0,0,1,1.689-.667h14.17a7.858,7.858,0,0,1,.993.192.665.665,0,0,0,.5-.061,15.539,15.539,0,0,0,1.444-1.641A67.407,67.407,0,0,0,24.664,15.8a3.145,3.145,0,0,0,.372-1.611c-.065-1.662-.065-3.328-.124-4.99a2.768,2.768,0,0,1,1.434-2.626,5.2,5.2,0,0,1,5.743.323,3.333,3.333,0,0,1,.883,1.343c.61,1.515,1.191,3.066,1.707,4.626a10.175,10.175,0,0,1,.208,5.243c-.258,1.328-.447,2.672-.67,4.005-.074.455-.06.505.4.505H45.341a4.527,4.527,0,0,1,2.482.6,3.813,3.813,0,0,1,1.653,2.4c.04.157.089.308.134.46v1.369ZM31.662,24.7c.387-2.338.779-4.626,1.137-6.914a10.34,10.34,0,0,0,.223-2.465A20.5,20.5,0,0,0,31.087,9.1a1.5,1.5,0,0,0-1.107-1.01,3.3,3.3,0,0,0-2.482.222.906.906,0,0,0-.541.919q.1,2.758.1,5.515a3.812,3.812,0,0,1-.213,1.288,8.88,8.88,0,0,1-.725,1.515c-1.489,2.48-2.978,4.97-4.507,7.42A9.452,9.452,0,0,1,18.946,28c-.7.465-1.415.939-2.1,1.429a.684.684,0,0,0-.273.465q0,7.493,0,14.98c0,.3.124.328.377.359a7.049,7.049,0,0,1,1.41.3,3.894,3.894,0,0,1,.879.54,4.334,4.334,0,0,0,2.531.773H40.453a8.328,8.328,0,0,0,1.107-.066,3.225,3.225,0,0,0,2.293-1.349,2.341,2.341,0,0,0,.129-2.839,6.062,6.062,0,0,0-1.147-.884.9.9,0,0,1,.318-.348,3.237,3.237,0,0,0,2.313-2.268,2.068,2.068,0,0,0-.635-2.349,8.188,8.188,0,0,0-1.112-.621,1.436,1.436,0,0,1,.442-.434,3.06,3.06,0,0,0,1.886-1.369c.958-1.48.6-3.03-.993-3.606a.436.436,0,0,1-.258-.273.378.378,0,0,1,.077-.28.366.366,0,0,1,.251-.139A3.123,3.123,0,0,0,47.491,27.3a2.031,2.031,0,0,0-1.082-2.328,3.578,3.578,0,0,0-1.38-.263H31.667Zm-16.94,3.364c-.159,0-.278-.025-.392-.025H2.577a.338.338,0,0,0-.337.09.353.353,0,0,0-.085.344q0,9.7,0,19.41a.389.389,0,0,0,.095.374.373.373,0,0,0,.367.1H14.211c.5,0,.5,0,.5-.53V28.083Z",
    transform: "translate(-0.081 -5.859)",
    fill: "#585858"
  })))))))))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThumb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumb.0249c417.svg";
export { ForwardRef as ReactComponent };